import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import storage from "../apis/Storage";

const checkPageAccess = (path, permittedPages, role) => {
  let isUserAuthorised = false;
  let allowedActions = [];
  let selectedPageName = [];

  // Administrators always have access
  if (role === "Administrator" || role === "RsoAdmin") {
    return {
      isUserAuthorised: true,
      allowedActions: [],
    };
  }

  if (Array.isArray(permittedPages) && permittedPages.length > 0) {
    const matchedPage = permittedPages.find(
      (page) => page.pageUrl.toLowerCase() === path.toLowerCase(),
    );

    isUserAuthorised = !!matchedPage;

    if (
      matchedPage &&
      Array.isArray(matchedPage.actions) &&
      matchedPage.actions.length > 0
    ) {
      const anyPermittedAction = matchedPage.actions.filter(
        (action) => action.isSystemAction === true || action.ischecked,
      );

      if (anyPermittedAction.length > 0) {
        allowedActions = [...matchedPage.actions];
      } else {
        isUserAuthorised = false;
      }
    }
  }

  return {
    isUserAuthorised,
    allowedActions,
  };
};

const _ProtectedRoute = ({
  component: Component,
  path,
  permittedPages,
  appToken,
  userRole,
  ...rest
}) => {
  const checkAccess = checkPageAccess(path, permittedPages, userRole);
  return (
    <Route
      {...rest}
      render={(props) => {
        // User not logged in
        if (!appToken) {
          return <Redirect to="/login" />;
        }

        // User logged in but does not have permission
        if (!checkAccess.isUserAuthorised) {
          return (
            <div className="container mt-5 text-center">
              <h3>Access Denied</h3>
              <p>
                You do not have permission to access <b>"{path}"</b> page.
              </p>
            </div>
          );
        }

        return (
          <Component
            {...props}
            actions={checkAccess.allowedActions}
            path={path}
          />
        );
      }}
    />
  );
};

const mapStateToProps = () => {
  let permittedPages = [];

  try {
    permittedPages = JSON.parse(storage.get("_userPermissionsList") || "[]");
  } catch (error) {
    console.error("Error parsing permissions:", error);
    permittedPages = [];
  }

  return {
    permittedPages,
    appToken: storage.get("_appToken"),
    userRole: storage.get("_appUserRole"),
  };
};

const RestrictedRoute = connect(mapStateToProps)(_ProtectedRoute);

export default RestrictedRoute;
